import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import BetButton from '../BetButton/';
import {
    SELECTION_COLUMN,
    SELECTION_COLUMN_INVERTED,
} from './constants';
import './styles/selection-column.scss';
import isUndefined from 'lodash/isUndefined';
import { selectionIsOverUnder, getSelectionLabel } from '~shared/utils/selections-utils';

const SelectionColumn = ({market, isUsFormat, numberOfSelections, gtmAttribute}) => {
    const [isOverUnder, setIsOverUnder] = useState();
    const selectionsArray = new Array(numberOfSelections);
    // The Selection element will display as a dash when the 'betable' attibute is false.
    // The selectionsArray is pre-populated with dashes and then the selections are added
    // based on their order in default_line_selections.
    selectionsArray.fill({betable: false}, 0, numberOfSelections);

    const {
        default_line_selections: defaultLine = [],
        selections: marketSelections = {},
        id: marketId,
    } = market;

    useEffect(() => {
        if (isOverUnder) {
            // if we already know it's over under there is no need to check it again.
            // however isOverUnder can change from false to true so we need to check again
            // when marketSelections change.
            return;
        }
        const [selection] = Object.values(marketSelections);
        setIsOverUnder(Boolean(selection && selectionIsOverUnder(selection)));
    }, [marketSelections]);

    defaultLine.forEach((selectionId, index) => {
        const selection = marketSelections[selectionId];
        if(selection) {
            selectionsArray[index] = selection;
        }
    });

    const buttons = selectionsArray
        .map((selection, index) => {
                const { id: selectionId } = selection;
                const label = getSelectionLabel({ selection });
                const shouldShowLabel = Boolean(label) && label.length > 0;

                return !isUndefined(isOverUnder) && (<BetButton
                    key={`${marketId}_${selectionId || index}`}
                    options={{...selection, id: selectionId, label}}
                    showSelectionLabels={shouldShowLabel}
                    doTranslateLabel={false}
                    gtmAttribute={gtmAttribute}
                />);
            }
        );

    const className = isUsFormat && !isOverUnder ? SELECTION_COLUMN_INVERTED : SELECTION_COLUMN;

    return <div className={className}>
        {buttons}
    </div>;
};

SelectionColumn.propTypes = {
    market: PropTypes.object.isRequired,
    numberOfSelections: PropTypes.number,
    isUsFormat: PropTypes.bool,
    gtmAttribute: PropTypes.string,
};

SelectionColumn.defaultProps = {
    market: {},
    numberOfSelections: 2,
    isUsFormat: false,
    gtmAttribute: '',
};

export default SelectionColumn;
